module.exports = __webpack_public_path__ + "img/logo1.725bed39.png";